import { Exchange } from '../enum/Exchange';

export class CryptoAddressDto {
  id: number;
  address: string;
  addressTag: string;
  chain: string;
  currency: string;
  exchange: Exchange;
  hashId: string;
  userId: string;
}
